/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CommunicationLanguage,
    CommunicationLanguageFromJSON,
    CommunicationLanguageFromJSONTyped,
    CommunicationLanguageToJSON,
    CommunicationSource,
    CommunicationSourceFromJSON,
    CommunicationSourceFromJSONTyped,
    CommunicationSourceToJSON,
    ObjectTypeEnum,
    ObjectTypeEnumFromJSON,
    ObjectTypeEnumFromJSONTyped,
    ObjectTypeEnumToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExternalCommunicationItem
 */
export interface ExternalCommunicationItem {
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunicationItem
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunicationItem
     */
    externalCommunicationId: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunicationItem
     */
    parentCommunicationId?: string | null;
    /**
     * 
     * @type {ObjectTypeEnum}
     * @memberof ExternalCommunicationItem
     */
    objectType: ObjectTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunicationItem
     */
    objectId: string;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunicationItem
     */
    communication?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ExternalCommunicationItem
     */
    createdDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExternalCommunicationItem
     */
    lastActivityDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof ExternalCommunicationItem
     */
    createdBy: string;
    /**
     * 
     * @type {CommunicationSource}
     * @memberof ExternalCommunicationItem
     */
    source?: CommunicationSource;
    /**
     * 
     * @type {CommunicationLanguage}
     * @memberof ExternalCommunicationItem
     */
    language?: CommunicationLanguage;
    /**
     * 
     * @type {boolean}
     * @memberof ExternalCommunicationItem
     */
    isGenerated?: boolean | null;
}

export function ExternalCommunicationItemFromJSON(json: any): ExternalCommunicationItem {
    return ExternalCommunicationItemFromJSONTyped(json, false);
}

export function ExternalCommunicationItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExternalCommunicationItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'externalCommunicationId': json['externalCommunicationId'],
        'parentCommunicationId': !exists(json, 'parentCommunicationId') ? undefined : json['parentCommunicationId'],
        'objectType': ObjectTypeEnumFromJSON(json['objectType']),
        'objectId': json['objectId'],
        'communication': !exists(json, 'communication') ? undefined : json['communication'],
        'createdDate': (new Date(json['createdDate'])),
        'lastActivityDate': !exists(json, 'lastActivityDate') ? undefined : (json['lastActivityDate'] === null ? null : new Date(json['lastActivityDate'])),
        'createdBy': json['createdBy'],
        'source': !exists(json, 'source') ? undefined : CommunicationSourceFromJSON(json['source']),
        'language': !exists(json, 'language') ? undefined : CommunicationLanguageFromJSON(json['language']),
        'isGenerated': !exists(json, 'isGenerated') ? undefined : json['isGenerated'],
    };
}

export function ExternalCommunicationItemToJSON(value?: ExternalCommunicationItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'externalCommunicationId': value.externalCommunicationId,
        'parentCommunicationId': value.parentCommunicationId,
        'objectType': ObjectTypeEnumToJSON(value.objectType),
        'objectId': value.objectId,
        'communication': value.communication,
        'createdDate': (value.createdDate.toISOString()),
        'lastActivityDate': value.lastActivityDate === undefined ? undefined : (value.lastActivityDate === null ? null : value.lastActivityDate.toISOString()),
        'createdBy': value.createdBy,
        'source': CommunicationSourceToJSON(value.source),
        'language': CommunicationLanguageToJSON(value.language),
        'isGenerated': value.isGenerated,
    };
}


